import { DELETE_UNDO_SECONDS } from "../model/commandeConstants";
import { validatePatients } from "../model/commandeValidation";

// Champs incomplets avant de quitter une commande pour une autre.
export function CommandeValidationModal({ vm }) {
    const { draft, setShowValidationModal, setPendingCommand, pendingCommand, setSelectedCommande, setView } = vm;
    return (
        <div style={{
            position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
            background: "rgba(0,0,0,0.4)",
            display: "flex", justifyContent: "center", alignItems: "center",
            zIndex: 1000
        }}>
            <div style={{ background: "white", padding: 24, borderRadius: 12, width: "460px" }}>
                <h3>Champs incomplets</h3>
                <ul>
                    {validatePatients(draft?.patients ?? []).map((e, i) => (
                        <li key={i}>{e}</li>
                    ))}
                </ul>
                <p>Vous devez corriger ces champs avant de quitter la commande.</p>
                <div style={{ display: "flex", gap: 10 }}>
                    <button onClick={() => { setShowValidationModal(false); setPendingCommand(null); }}>
                        Rester ici
                    </button>
                    <button onClick={() => {
                        setShowValidationModal(false);
                        if (pendingCommand) {
                            setSelectedCommande(pendingCommand);
                            setView("detail");
                            setPendingCommand(null);
                        }
                    }}>
                        Ignorer et quitter
                    </button>
                </div>
            </div>
        </div>
    );
}

// Patient homonyme déjà enregistré dans l'EHPAD : mettre à jour, créer un homonyme ou restaurer la date.
export function PatientIdentityConflictDialog({ vm }) {
    const { patientIdentityConflict, cancelPatientIdentityConflict, resolvePatientIdentityConflict } = vm;
    return (
        <div
            role="dialog"
            aria-modal="true"
            aria-labelledby="patient-identity-conflict-title"
            style={{
                position: "fixed",
                inset: 0,
                background: "rgba(15, 23, 42, 0.55)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 10000,
                padding: "20px",
            }}
        >
            <div style={{
                background: "white",
                borderRadius: "12px",
                width: "520px",
                maxWidth: "100%",
                padding: "24px",
                boxShadow: "0 20px 50px rgba(15, 23, 42, 0.25)",
            }}>
                <h3 id="patient-identity-conflict-title" style={{ margin: "0 0 12px" }}>
                    Ce patient existe déjà
                </h3>
                <p style={{ margin: "0 0 10px", color: "#334155" }}>
                    <strong>
                        {patientIdentityConflict.nom} {patientIdentityConflict.prenom}
                    </strong>
                    {" "}est déjà enregistré dans cet EHPAD.
                </p>
                <p style={{ margin: "0 0 20px", color: "#64748b", fontSize: "14px" }}>
                    Date existante : {patientIdentityConflict.existingDateNaissance || "non renseignée"}
                    <br />
                    Date saisie : {patientIdentityConflict.requestedDateNaissance || "non renseignée"}
                </p>
                <p style={{ color: "#334155" }}>
                    Voulez-vous mettre à jour le patient existant ou créer un nouveau patient homonyme ?
                </p>
                <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "20px" }}>
                    <button
                        onClick={cancelPatientIdentityConflict}
                        style={{
                            padding: "9px 14px",
                            borderRadius: "7px",
                            border: "1px solid #cbd5e1",
                            background: "#f8fafc",
                            cursor: "pointer",
                        }}
                    >
                        Annuler et restaurer la date
                    </button>
                    <button
                        onClick={() => resolvePatientIdentityConflict("CREATE_NEW")}
                        style={{
                            padding: "9px 14px",
                            borderRadius: "7px",
                            border: "1px solid #cbd5e1",
                            background: "white",
                            cursor: "pointer",
                        }}
                    >
                        Nouveau patient
                    </button>
                    <button
                        onClick={() => resolvePatientIdentityConflict("UPDATE_EXISTING")}
                        style={{
                            padding: "9px 14px",
                            borderRadius: "7px",
                            border: "none",
                            background: "#2563eb",
                            color: "white",
                            cursor: "pointer",
                            fontWeight: 600,
                        }}
                    >
                        Mettre à jour le patient
                    </button>
                </div>
            </div>
        </div>
    );
}

// Confirmation de suppression d'un mail, annulable ensuite pendant le délai affiché.
export function DeleteMailConfirmDialog({ vm }) {
    const { setDeleteConfirmationCommand, deleteCancelButtonRef, confirmDeleteFromDetail } = vm;
    return (
        <div
            role="dialog"
            aria-modal="true"
            aria-labelledby="delete-mail-confirmation-title"
            aria-describedby="delete-mail-confirmation-description"
            style={{
                position: "fixed",
                inset: 0,
                background: "rgba(15, 23, 42, 0.55)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 10000,
                padding: "20px",
            }}
        >
            <div style={{
                background: "white",
                borderRadius: "12px",
                width: "440px",
                maxWidth: "100%",
                padding: "24px",
                boxShadow: "0 20px 50px rgba(15, 23, 42, 0.25)",
            }}>
                <h3 id="delete-mail-confirmation-title" style={{ margin: "0 0 12px", color: "#0C3B3C" }}>
                    Supprimer ce mail ?
                </h3>
                <p id="delete-mail-confirmation-description" style={{ margin: 0, color: "#5A6D68", lineHeight: 1.5 }}>
                    Voulez-vous vraiment supprimer ce mail du suivi ? Vous disposerez ensuite de {DELETE_UNDO_SECONDS} secondes pour annuler.
                </p>
                <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "24px" }}>
                    <button
                        ref={deleteCancelButtonRef}
                        type="button"
                        onClick={() => setDeleteConfirmationCommand(null)}
                        style={{
                            padding: "9px 16px",
                            borderRadius: "7px",
                            border: "1px solid #cbd5e1",
                            background: "white",
                            color: "#334155",
                            cursor: "pointer",
                            fontWeight: 600,
                        }}
                    >
                        Annuler
                    </button>
                    <button
                        type="button"
                        onClick={confirmDeleteFromDetail}
                        style={{
                            padding: "9px 16px",
                            borderRadius: "7px",
                            border: "none",
                            background: "#dc2626",
                            color: "white",
                            cursor: "pointer",
                            fontWeight: 600,
                        }}
                    >
                        Supprimer
                    </button>
                </div>
            </div>
        </div>
    );
}

// Confirmation d'enregistrement au retour à la liste.
export function SavedToast({ vm }) {
    return (
        <div style={{
            position: "fixed", bottom: "24px", left: "50%",
            transform: "translateX(-50%)",
            background: "#16a34a", color: "white",
            padding: "10px 20px", borderRadius: "8px",
            fontSize: "13px", fontWeight: 600,
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            zIndex: 9999,
            display: "flex", alignItems: "center", gap: "8px",
        }}>
            ✓ Commande sauvegardée
        </div>
    );
}

// Mails supprimés en attente, avec le compte à rebours pour annuler.
export function PendingDeleteToasts({ vm }) {
    const { pendingDeleteDetails, handleCancelDeleteDetail } = vm;
    return (
        <div style={{
            position: "fixed",
            bottom: "24px",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 9999,
            minWidth: "340px",
            maxWidth: "90vw",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
        }}>
            {pendingDeleteDetails.map(item => (
                <div key={item.cmd.id} style={{
                    background: "#1e293b",
                    color: "white",
                    borderRadius: "10px",
                    boxShadow: "0 4px 20px rgba(0,0,0,0.25)",
                    overflow: "hidden",
                }}>
                    <div style={{ padding: "14px 16px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: "16px" }}>
                        <span style={{ fontSize: "13px" }}>
                            Mail supprimé — {item.secondsLeft}s pour annuler
                        </span>
                        <button
                            onClick={() => handleCancelDeleteDetail(item.cmd.id)}
                            style={{
                                background: "none",
                                border: "1px solid rgba(255,255,255,0.3)",
                                borderRadius: "6px",
                                color: "white",
                                padding: "4px 12px",
                                fontSize: "13px",
                                fontWeight: 600,
                                cursor: "pointer",
                                flexShrink: 0,
                            }}
                            onMouseEnter={e => e.currentTarget.style.background = "rgba(255,255,255,0.1)"}
                            onMouseLeave={e => e.currentTarget.style.background = "none"}
                        >
                            Annuler
                        </button>
                    </div>
                    <div style={{ height: "3px", background: "rgba(255,255,255,0.15)" }}>
                        <div style={{
                            height: "100%",
                            background: "#60a5fa",
                            width: `${(item.secondsLeft / DELETE_UNDO_SECONDS) * 100}%`,
                            transition: "width 0.9s linear",
                        }} />
                    </div>
                </div>
            ))}
        </div>
    );
}
